import { useEffect } from "react";
import { Card } from "@/components/ui/card";

type Props = { zoneId: string; className?: string; };

export default function AdSlot({ zoneId, className }: Props) {
  useEffect(() => {
    // TODO: wire to /v1/zones/{zoneId}/serve per contract when backend is ready
    // Consent + frequency caps go here.
    // eslint-disable-next-line no-console
    console.debug("AdSlot mount", { zoneId });
  }, [zoneId]);

  return (
    <Card className={className ?? "bg-muted aspect-video flex items-center justify-center text-xs text-muted-foreground"}>
      Ad Zone: {zoneId}
    </Card>
  );
}
